import React from "react";
import LocalOfferIcon from "@material-ui/icons/LocalOffer";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { TextField, Tooltip } from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import InputAdornment from "@material-ui/core/InputAdornment";

export default function Tag(props) {
  return (
    <div style={{ display: "flex" }}>
      <Typography display={"inline"}>{props.name}</Typography>
      <TextField
        error={props.error}
        value={props.tag}
        onChange={(e) => props.handleEditTag(e.target.value)}
        variant="standard"
        size={"small"}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <LocalOfferIcon />
            </InputAdornment>
          ),
        }}
      />
      <Tooltip title={"delete"}>
        <HighlightOffIcon onClick={() => props.onDelete()} />
      </Tooltip>
    </div>
  );
}
